import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

import Layout from '@/views/layout'

import adminRouter from './modules/admin'
import workRouter from './modules/work'

export const asyncRoutes = [
  ...adminRouter,
  ...workRouter,
  { path: '*', redirect: '/404', hidden: true }
]

export const constantRoutes = [{
	path: '/redirect',
	component: Layout,
	hidden: true,
	children: [{
		path: '/redirect/:path(.*)',
		component: () => import('@/views/redirect/index')
	}]
}, {
	path: '/login',
	component: () => import('@/views/login/index'),
	hidden: true
}, {
	path: '/profile',
	hidden: true,
  component: Layout,
  children: [{
    path: '',
    name: 'Profile',
    meta: {title: '修改密码'},
    component: () => import('@/views/profile/index'),
  }]
}, {
	path: '/404',
	component: () => import('@/views/error-page/404'),
	hidden: true
}, {
	path: '/401',
	component: () => import('@/views/error-page/401'),
	hidden: true
}, {
	path: '/',
	component: Layout,
	redirect: '/dashboard',
	children: [{
		path: 'dashboard',
		name: 'Dashboard',
		meta: { title: '首页', icon: 'dashboard', affix: true },
		component: () => import('@/views/dashboard/index')
	}]
}]

const router = new VueRouter({
  routes: constantRoutes,
  scrollBehavior: () => ({x: 0, y:0})
})

export default router
